import { Heart, Eye } from "lucide-react";
import { Card } from "@/components/ui/card";

interface TechArticleCardProps {
  image: string;
  title: string;
  description: string;
  views: number;
  liked: boolean;
  likes: number;
  onLike: () => void;
  onClick?: () => void;
}

export const TechArticleCard = ({ image, title, description, views, liked, likes, onLike, onClick }: TechArticleCardProps) => {
  const handleLike = (e: React.MouseEvent) => {
    e.stopPropagation();
    onLike();
  };

  return (
    <Card className="relative overflow-hidden group cursor-pointer transition-all duration-300 hover:shadow-xl hover:-translate-y-1" onClick={onClick}>
      <div className="relative h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
        
        {/* Views badge */}
        <div className="absolute top-3 left-3 flex items-center gap-1 bg-primary/90 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-full">
          <Eye className="w-3 h-3" />
          <span className="font-medium">{views.toLocaleString('it-IT')}</span>
        </div>

        {/* Like button */}
        <button 
          onClick={handleLike}
          className="absolute top-3 right-3 p-2 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-all duration-200 hover:scale-110"
        >
          <Heart 
            className={`w-4 h-4 transition-colors ${liked ? 'fill-red-500 text-red-500' : 'text-white'}`}
          />
        </button>

        {/* Title on image */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-white font-bold text-lg leading-tight mb-1">
            {title}
          </h3>
        </div>
      </div>

      {/* Description below image */}
      <div className="p-4 bg-card">
        <p className="text-sm text-muted-foreground line-clamp-2 leading-relaxed">
          {description}
        </p>
        <div className="flex items-center gap-2 mt-2 text-xs text-muted-foreground">
          <Heart className="w-3 h-3" />
          <span>{likes} like</span>
        </div>
      </div>
    </Card>
  );
};